export const person16ServiceFactory = ['app.config', '$http', '$q', '$timeout', person16Service];

function person16Service(config, $http, $q, $timeout) {
    var service = {
        setPersonFocus: setPersonFocus,
        fetchProgress: fetchProgress,
        updateEntity: updateEntity,
        updateEntityHistory: updateEntityHistory,
        entityStatus: entityStatus,
    };

    return service;

    ////
    function setPersonFocus(args, retries) {
        if (retries == undefined) {
            retries = 2;
        }

        console.log('personService.setPersonFocus()');

        var postArgs = {
            action: 'focus',
            args: args,
        };

        return $http.post(config.api, postArgs).then(
            function (response) {
                return response;
            },
            function (response) {
                if (response.status == 500 && retries-- > 0) {
                    console.log('setPersonFocus - $http error - retry ' + retries);
                    return setPersonFocus(args, retries);
                } else {
                    console.log('setPersonFocus - $http error - promise rejected');
                    return $q.reject(response);
                }
            }
        );
    }

    function fetchProgress(type, retries) {
        if (retries == undefined) {
            retries = 0;
        }

        var postArgs = {
            action: 'uploadProgress',
            type: type,
        };

        // set the person object
        return $http.post(config.api, postArgs).then(
            function (response) {
                return response;
            },
            function (response) {
                if (response.status == 500 && retries-- > 0) {
                    console.log('fetchProgress - $http error - retry ' + retries);
                    return fetchProgress(type, retries);
                } else {
                    console.log('fetchProgress - $http error - promise rejected - returning $q.reject(response)');
                    return $q.reject(response);
                }
            }
        );
    }

    function updateEntity(entity, retries) {
        if (retries == undefined) {
            retries = 5;
        }

        console.log('personService.updateEntity()');

        var postArgs = {
            action: 'updateEntity',
            entity: entity,
        };

        return $http.post(config.api, postArgs).then(
            function (response) {
                return response;
            },
            function (response) {
                if (response.status == 500 && retries-- > 0) {
                    console.log('updateEntity - $http error - retry ' + retries);
                    return updateEntity(entity, retries);
                } else {
                    console.log('updateEntity - $http error - promise rejected');
                    return $q.reject(response);
                }
            }
        );
    }

    function updateEntityHistory(args, retries) {
        if (retries == undefined) {
            retries = 5;
        }

        console.log('personService.updateEntityHistory()');

        const postArgs = {
            action: 'updateEntityHistory',
            args: args,
        };

        return $http.post(config.api, postArgs).then(
            function (response) {
                return response;
            },
            function (response) {
                if (response.status == 500 && retries-- > 0) {
                    console.log('updateEntityHistory - $http error - retry ' + retries);
                    return updateEntityHistory(args, retries);
                } else {
                    console.log('updateEntityHistory - $http error - promise rejected');
                    return $q.reject(response);
                }
            }
        );
    }

    function entityStatus(args, retries) {
        if (retries == undefined) {
            retries = 5;
        }

        console.log('personService.entityStatus()');

        const postArgs = {
            action: 'entityStatus',
            searchArgs: args,
        };

        return $http.post(config.api, postArgs).then(
            function (response) {
                return response;
            },
            function (response) {
                if (response.status == 500 && retries-- > 0) {
                    console.log('entityStatus - $http error - retry ' + retries);
                    return entityStatus(args, retries);
                } else {
                    console.log('entityStatus - $http error - promise rejected');
                    return $q.reject(response);
                }
            }
        );
    }
}
